var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodayShopLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    horizAdvX: 0
  }, /*#__PURE__*/React.createElement("fontFace", {
    ascent: 800,
    bbox: "-150 -273 1070 840",
    capHeight: 656,
    descent: -200,
    panose1: "2 0 5 6 4 0 0 2 0 3",
    underlinePosition: -108,
    underlineThickness: 23,
    unicodeRange: "U+0020-U+E003",
    xHeight: 437
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 176
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".notdef",
    horizAdvX: 176
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: ".null"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "nonmarkingreturn",
    horizAdvX: 333
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    horizAdvX: 176,
    unicode: " "
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M69 656h67l-12-512h-40zM104 79q18 0 29-12t11-32q0-19-11-30.5t-28-11.5-28 12-11 31 10.5 31 27.5 12z",
    glyphName: "exclam",
    horizAdvX: 182,
    unicode: "!"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M112 675l53-6q-14-122-99-248l-46 10q80 137 92 244zM247 675l52-6q-14-121-99-248l-46 10q79 136 93 244z",
    glyphName: "quotedbl",
    horizAdvX: 324,
    unicode: "\""
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M484 256l-5-37h-106l-35-219h-40l34 219h-140l-35-219h-40l35 219h-106l6 37h106l23 147h-106l6 37h106l34 216h40l-34-216h140l35 216h40l-35-216h106l-6-37h-105l-24-147h106zM362 403h-141l-23-147h140z",
    glyphName: "numbersign",
    horizAdvX: 558,
    unicode: "#"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M208 715v-85q74-9 130-53l-26-51q-58 49-121 52-44 2-76-27t-32-72q0-53 40-81 17-13 48-26l26-11 25-12 26-11q73-30 101-89 14-29 14-74 0-43-24-83t-61-60q-28-15-70-22v-97h-44v94q-58 7-90 20t-69 45l14 59q51-43 84.5-58t77.5-15q54 0 88.5 31.5t34.5 81.5-28 78q-22 22-57 37l-26 12-26 11-26 12q-61 26-88 63t-27 93 38.5 98 99.5 52v88h44z",
    glyphName: "dollar",
    horizAdvX: 385,
    unicode: "$"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M174 646q69 4 114.5-47.5t45.5-133.5q0-87-44.5-139.5t-118.5-52.5q-68 0-110.5 52.5t-42.5 136.5q0 78 43 129t113 55zM172 602q-48 0-74.5-36.5t-26.5-102.5q0-64 29.5-104.5t75.5-40.5q103 0 103 143 0 60-30 102-28 39-77 39zM477 645h46l-264-645h-46zM557 372q69 4 114.5-48t45.5-133q0-87-44.5-139.5t-118.5-52.5q-68 0-110.5 52.5t-42.5 136.5q0 79 43 129.5t113 54.5zM555 328q-48 0-74.5-36.5t-26.5-102.5q0-64 29.5-104.5t75.5-40.5q103 0 103 143 0 60-30 102-28 39-77 39z",
    glyphName: "percent",
    horizAdvX: 736,
    unicode: "%"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M851 458v-51h-113q-5-121-43-208-41-94-131-151.5t-194-57.5q-166 0-264 113-81 93-81 220 0 123 85 202 32 30 75.5 48t83.5 18q157 0 221-140v-44l-362-224q40-65 102.5-101t134.5-36q205 0 280 188 30 75 30 173h-123v51h299zM106 229l331 202q-26 53-72.5 81t-102.5 24q-75-4-122.5-58t-52.5-138q-3-56 19-111z",
    glyphName: "ampersand",
    horizAdvX: 857,
    unicode: "&"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M112 675l53-6q-14-122-99-248l-46 10q80 137 92 244z",
    glyphName: "quotesingle",
    horizAdvX: 191,
    unicode: "'"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M192 719l31-31q-145-168-145-357t149-360l-36-33q-88 94-127 186t-39 208q0 100 43.5 200.5t123.5 186.5z",
    glyphName: "parenleft",
    horizAdvX: 235,
    unicode: "("
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M41-62l-31 31q146 166 146 357 0 188-149 360l36 33q89-94 127.5-186t38.5-209q0-100-44-200.5t-124-185.5z",
    glyphName: "parenright",
    horizAdvX: 235,
    unicode: ")"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M214 709l-7-145 136 53 15-45-137-42 88-114-38-26-81 120-79-120-38 26 86 114-136 42 15 45 135-53-7 145h48z",
    glyphName: "asterisk",
    horizAdvX: 381,
    unicode: "*"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M44 341h190v192h50v-192h189v-47h-189v-191h-50v191h-190v47z",
    glyphName: "plus",
    horizAdvX: 513,
    unicode: "+"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 108l54-6q-13-140-108-265l-47 11q50 83 71 137.5t30 122.5z",
    glyphName: "comma",
    horizAdvX: 130,
    unicode: ","
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M34 264h219l-9-51h-219z",
    glyphName: "hyphen",
    horizAdvX: 278,
    unicode: "-"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M63 79q18 0 29-12t11-32q0-19-11-30.5t-28-11.5-28 12-11 31 10.5 31 27.5 12z",
    glyphName: "period",
    horizAdvX: 128,
    unicode: "."
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M343 706h51l-330-755h-51z",
    glyphName: "slash",
    horizAdvX: 408,
    unicode: "/"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M237 648q95 5 153-84t58-239q0-157-56.5-247t-154.5-90q-101 0-156.5 88t-55.5 248q0 143 57.5 231t154.5 93zM233 598q-30 0-57.5-16.5t-43.5-44.5q-45-77-45-204 0-135 37.5-211.5t107.5-82.5q73-6 113.5 69t40.5 218q0 123-44 201-17 32-47 51.5t-62 19.5z",
    glyphName: "zero",
    horizAdvX: 474,
    unicode: "0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M262 636v-636h-58v566q-109-83-176-120l-28 35q56 32 114 74 66 46 125 93z",
    glyphName: "one",
    horizAdvX: 317,
    unicode: "1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M445 53l-12-53h-417l-9 32q87 82 177 181 67 73 110 134 40 57 43 120 3 53-35 91t-94 38q-65 0-130-64l-33 36q37 38 60 51 52 30 102 30 88 0 140-49.5t52-133.5q0-89-109-214-75-86-193-199h348z",
    glyphName: "two",
    horizAdvX: 451,
    unicode: "2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M112 354h108q22 0 47 24 49 45 49 105 0 49-35.5 81t-89.5 32q-76 0-128-60l-37 36q70 76 166 76 82 0 133-44t51-115q0-88-98-148 61-21 93-63t32-101q0-83-59.5-136t-152.5-53q-117 0-191 80l36 40q66-69 155-69 68 0 108.5 36t40.5 97q0 34-18 65.5t-48 49.5q-31 20-98 20h-64v47z",
    glyphName: "three",
    horizAdvX: 422,
    unicode: "3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M376 636v-397h105l-6-46h-99v-193h-57v193h-300l-12 37 340 417zM319 239v310q-30-43-62-83l-123-151q-29-36-69-76h254z",
    glyphName: "four",
    horizAdvX: 488,
    unicode: "4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M161 584l-31-177h18q122 0 183-61 60-57 60-144 0-95-63.5-154.5t-164.5-59.5q-90 0-163 52l28 45q65-47 135-47 76 0 121.5 43t45.5 115q0 77-56.5 119.5t-159.5 42.5q-2 0-19-.5t-27-.5l47 279h258v-52h-212z",
    glyphName: "five",
    horizAdvX: 408,
    unicode: "5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M348 663l44-31q-119-47-193-123-43-45-67-87.5t-45-113.5q37 47 72.5 67.5t84.5 24.5q82 6 141-51t59-143q0-97-58.5-157.5t-153.5-60.5q-56 0-102 27t-73 76q-34 59-34 155 0 115 73 222 87 128 252 195zM83 247v-40q0-68 46-118.5t107-50.5q68 0 107.5 43.5t39.5 118.5q0 65-46 109t-107 39q-80-8-129-74-18-25-18-27z",
    glyphName: "six",
    horizAdvX: 460,
    unicode: "6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M7 636h404l10-26-15-30-15-29-162-321-113-241-58 19 66 141 150 296q28 54 77 140h-344v51z",
    glyphName: "seven",
    horizAdvX: 429,
    unicode: "7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M282 343q63-24 91-47 58-48 58-125 0-82-56.5-132.5t-148.5-50.5q-90 0-148 50.5t-58 129.5q0 41 20.5 78t56.5 61q23 16 72 33-58 23-85 53-37 40-37 95 0 68 51 114t125 46q80 0 130.5-42.5t50.5-109.5q0-79-58-122-19-14-64-31zM238 363q59 26 84 55.5t25 72.5q0 48-34 79t-86 31q-56 0-89.5-30t-31.5-79q3-58 66-98 11-7 36-18 29-14 30-13zM214 319q-73-30-103.5-64.5t-30.5-88.5q0-55 42.5-93t103.5-38q68 0 107.5 36.5t36.5 97.5q-3 71-78 114-20 12-44 22-33 15-34 14z",
    glyphName: "eight",
    horizAdvX: 451,
    unicode: "8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M119-27l-53 27q121 51 199 135 40 43 62 83.5t41 104.5q-70-85-162-85-89 0-144 66-44 51-44 136 0 84 61 146t143 62q98 0 154-67.5t56-186.5q0-92-45-180.5t-128-157.5q-57-47-140-83zM371 378q1 9 1 22 0 86-44 142-40 54-113 54-58 0-97.5-44.5t-39.5-109.5q0-66 42-110t102-41q69 3 120 54 29 31 29 33z",
    glyphName: "nine",
    horizAdvX: 456,
    unicode: "9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M92 86q18 0 29-12t11-32q0-19-11-30.5t-28-11.5-28 12.5-11 31.5q0 18 11 30t27 12zM93 437q18 0 29-12t11-32q0-19-11-30.5t-28-11.5-28 12.5-11 31.5q0 18 11 30t27 12z",
    glyphName: "colon",
    horizAdvX: 164,
    unicode: ":"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M78 108l54-6q-13-140-108-265l-47 11q50 83 71 137.5t30 122.5zM96 437q18 0 29-12t11-32q0-19-11-30.5t-28-11.5-28 12.5-11 31.5q0 18 11 30t27 12z",
    glyphName: "semicolon",
    horizAdvX: 164,
    unicode: ";"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183 416l19-40-126-151 126-149-19-47-163 194zM329 416l20-40-127-151 127-149-20-47-162 194z",
    glyphName: "less",
    horizAdvX: 374,
    unicode: "<"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M49 416h418v-47h-418v47zM49 267h418v-47h-418v47z",
    glyphName: "equal",
    horizAdvX: 513,
    unicode: "="
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M191 29l-19 41 126 150-126 150 19 46 163-193zM45 29l-20 41 127 150-127 150 20 46 162-193z",
    glyphName: "greater",
    horizAdvX: 374,
    unicode: ">"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M51 581l-26 38q64 47 138 47 72 0 122-46.5t50-113.5q0-78-69-158l-29-33.5-22-25.5t-9-10q-38-46-38-109 0-16 1-25h-52q-2 20-2 26 0 43 12 73.5t46 72.5q48 59 59 73.5t20 32.5q20 39 20 81 0 46-35.5 78.5t-84.5 32.5q-31 0-51.5-7t-49.5-27zM143 78q18 0 29-12t11-31-11-30.5-28-11.5-28 12-11 31q0 18 11 30t27 12z",
    glyphName: "question",
    horizAdvX: 360,
    unicode: "?"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M972 306q0-105-48.5-178t-145.5-107q-61-21-113-21h-80l14 91q-23-41-68-66t-92-25q-65 0-93 45t-28 114q0 118 69 209t183 91q55 0 132-18l-57-393h33q50 2 97 24 142 66 142 229 0 150-97 231.5t-251 81.5q-112 0-211-54.5t-159-150-60-208.5q0-176 92-266t270-90q136 0 236 44l12-46q-105-46-254-46-200 0-305.5 101t-105.5 299q0 105 50 203 63 123 181 191t258 68q170 0 284.5-93.5t114.5-259.5zM643 406q-37 8-71 8-92 0-145.5-78.5t-53.5-175.5q0-113 83-113 42 0 82 31.5t65 73.5z",
    glyphName: "at",
    horizAdvX: 1056,
    unicode: "@"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238z",
    glyphName: "A",
    horizAdvX: 565,
    unicode: "A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 4v650q89 8 136 8 97 0 153-43.5t56-118.5q0-86-99-146 61-13 94-45 55-52 55-130 0-51-27.5-94t-74.5-66q-53-25-129-25-64 0-164 10zM114 610v-244h118q32 0 64 38t37 82q5 57-36 92t-113 35q-31 0-70-3zM114 319v-267q55-8 105-8 75 0 119 36t44 97q0 41-21 74.5t-58 51.5q-37 16-99 16h-90z",
    glyphName: "B",
    horizAdvX: 470,
    unicode: "B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M554 617l-28-53q-90 49-175 49-115 0-187.5-78.5t-72.5-202.5q0-119 73-201 34-39 86.5-62.5t102.5-23.5q106 0 183 51l24-49q-87-61-210-61-65 0-128 26.5t-107 72.5q-90 93-90 249 0 68 27 134t73 110q94 92 232 92 106 0 197-53z",
    glyphName: "C",
    horizAdvX: 561,
    unicode: "C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 4v649q79 7 155 7 191 0 290-94 98-93 98-244 0-86-36-157t-100-112q-45-29-116-44-65-13-122-13h-45q-53 0-124 8zM114 605v-549q49-7 108-7 152 0 229.5 70.5t77.5 208.5q0 67-33.5 129.5t-87.5 97.5q-73 46-202 52-40 2-92-2z",
    glyphName: "D",
    horizAdvX: 620,
    unicode: "D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M391 656v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v656h339z",
    glyphName: "E",
    horizAdvX: 435,
    unicode: "E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M377 656v-52h-262v-244h234v-52h-234v-308h-62v656h324z",
    glyphName: "F",
    horizAdvX: 383,
    unicode: "F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M600 590l-35-50q-89 74-204 74-120 0-194.5-79t-74.5-205q0-63 26.5-123.5t70.5-98.5q34-30 84.5-48.5t98.5-18.5q60 0 93 7.5t75 31.5v191h-171l8 52h225v-271q-104-66-233-66-153 0-248.5 96t-95.5 250q0 142 97 240t237 98q141 0 241-80z",
    glyphName: "G",
    horizAdvX: 650,
    unicode: "G"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 370h382v286h62v-656h-62v318h-382v-318h-62v656h62v-286z",
    glyphName: "H",
    horizAdvX: 611,
    unicode: "H"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 656v-656h-62v656h62z",
    glyphName: "I",
    horizAdvX: 166,
    unicode: "I"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 656v-478q0-93-32-134-41-54-124-54-60 0-114 25l15 53q46-23 88-23 61 0 83 32t22 119v460h62z",
    glyphName: "J",
    horizAdvX: 324,
    unicode: "J"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 656h62v-334l337 343 59-18-285-289 297-358h-78l-263 320-67-69v-251h-62v656z",
    glyphName: "K",
    horizAdvX: 511,
    unicode: "K"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 656v-602h297l-10-54h-349v656h62z",
    glyphName: "L",
    horizAdvX: 413,
    unicode: "L"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M686 660l76-660h-61l-43 400q-1 8-3.5 34t-3.5 40q0 2-.5 9t-2.5 28l-2 18-1 18q-32-84-60-147l-177-400h-42l-179 398q-30 66-61 145l-1-17-2-18q-2-24-3-37-2-25-5-50 0-4-.5-9t-1-8-.5-6l-42-398h-55l73 660h42l195-431 65-150 5 12 58 138 190 431h42z",
    glyphName: "M",
    horizAdvX: 777,
    unicode: "M"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 654l34 11 345-414 117-145q0 18-.5 30.5t-.5 16v7 5 8.5q-1 34-1 76v407h55v-653l-30-11-348 417-47 57-71 88v-16q1-45 1-50 1-37 1-77v-411h-55v654z",
    glyphName: "N",
    horizAdvX: 654,
    unicode: "N"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83z",
    glyphName: "O",
    horizAdvX: 711,
    unicode: "O"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 0v654q23 1 38 3 60 5 104 5 128 0 187-52 57-51 57-142 0-50-27.5-95.5t-72.5-68.5q-53-28-145-28-21 0-79 2v-278h-62zM114 606v-277q30-2 80-2 85 0 132.5 38t47.5 106q0 139-182 139-27 0-78-4z",
    glyphName: "P",
    horizAdvX: 454,
    unicode: "P"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M839-107l-63-47q-89 17-159 54t-141 106q-60-20-122-20-143 0-236 98t-93 250q0 141 94.5 238.5t230.5 97.5q152 0 244.5-94t92.5-249q0-96-40.5-172.5t-114.5-122.5q46-44 108-76 82-41 199-63zM349 615q-115 0-186-78t-71-203q0-62 23-119.5t63-96.5q34-34 82.5-54.5t94.5-20.5q147 0 218 105 48 69 48 177 0 124-78 207t-194 83z",
    glyphName: "Q",
    horizAdvX: 711,
    unicode: "Q"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 0v653q75 9 153 9 121 0 178-60 48-51 48-125 0-61-36-109t-98-68l211-300h-76l-195 285h-123v-285h-62zM114 608v-274h131q50 0 87 41.5t37 97.5q0 64-44.5 101t-121.5 37h-23q-20 0-66-3z",
    glyphName: "R",
    horizAdvX: 497,
    unicode: "R"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M373 612l-27-54q-68 57-133 57-51 0-84-29.5t-35-78.5q-3-62 49-95 23-15 53-29l20-10 21-9 20-10q86-40 112-85 24-41 24-97 0-81-57.5-133.5t-146.5-52.5q-100 0-187 69l16 64q85-79 170-79 66 0 104 34t38 93q0 62-45 96-20 16-59 35l-60 27q-73 34-102.5 72.5t-29.5 99.5q0 73 52.5 123t128.5 50q91 0 158-58z",
    glyphName: "S",
    horizAdvX: 415,
    unicode: "S"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M302 604v-604h-62v604h-235v52h531v-52h-234z",
    glyphName: "T",
    horizAdvX: 540,
    unicode: "T"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392z",
    glyphName: "U",
    horizAdvX: 620,
    unicode: "U"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M61 665l175-435q40-99 58-158l25 70 16.5 45t11.5 31 5 12l173 435 56-16-263-649h-50l-266 649z",
    glyphName: "V",
    horizAdvX: 584,
    unicode: "V"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M393 665l172-432q24-60 57-159 17 52 24 70t32 89l170 432 55-16-260-649h-48l-144 363-141-363h-48l-260 649 59 16 173-437q25-61 58-156l68 177 68 167-93 233z",
    glyphName: "W",
    horizAdvX: 905,
    unicode: "W"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M296 385l214 282 56-19-237-305 258-335-63-19-231 308-235-308-56 19 257 335-235 305 60 19z",
    glyphName: "X",
    horizAdvX: 588,
    unicode: "X"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 355l206 312 55-18-233-349v-300h-62v300l-236 349 61 18z",
    glyphName: "Y",
    horizAdvX: 536,
    unicode: "Y"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M41 656h460l11-24-415-578h436l-10-54h-508l-11 24 417 580h-380v52z",
    glyphName: "Z",
    horizAdvX: 538,
    unicode: "Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M216-49h-164v755h172l-8-44h-112v-667h120z",
    glyphName: "bracketleft",
    horizAdvX: 230,
    unicode: "["
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M15 706h164v-755h-172l8 44h112v667h-120z",
    glyphName: "bracketright",
    horizAdvX: 230,
    unicode: "]"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM153 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM414 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "asciicircum",
    horizAdvX: 565,
    unicode: "^"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M0-118h397v-23h-397v23z",
    glyphName: "underscore",
    horizAdvX: 397,
    unicode: "_"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-78 680l136-130-37-15-158 130z",
    glyphName: "grave",
    unicode: "`"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42z",
    glyphName: "a",
    horizAdvX: 388,
    unicode: "a"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 706h57v-306q70 45 124 45 95 0 151-62t56-167q0-96-63.5-161.5t-156.5-65.5q-86 0-168 47v670zM107 355v-291q59-30 110-30 74 0 117.5 51t43.5 138q0 78-50 130-43 43-111 43-50 0-110-41z",
    glyphName: "b",
    horizAdvX: 463,
    unicode: "b"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M380 404l-29-43q-57 38-110 38-68 0-112-48.5t-44-124.5q0-78 43-129.5t113-55.5q56-4 122 35l22-40q-63-47-144-47-97 0-156.5 64.5t-59.5 171.5q0 92 63 158t152 66q79 0 140-45z",
    glyphName: "c",
    horizAdvX: 388,
    unicode: "c"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M357 706h57v-586q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-60 0-74 51-36-29-67.5-40.5t-77.5-11.5q-44 0-85 22t-67 60q-40 57-40 147 0 93 62 160t148 67q37 0 60.5-6t61.5-25v292zM357 83v273q-60 45-121 42-65-3-108-54t-43-126q0-78 42-129t106-51q40 0 64.5 9t59.5 36z",
    glyphName: "d",
    horizAdvX: 476,
    unicode: "d"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 239h-300v-19q0-77 45.5-128.5t114.5-51.5q78 0 133 52l30-33q-69-70-172-70-50 0-95 23t-74 64q-41 58-41 152 0 90 60 155.5t142 65.5q111 0 158-90 21-37 22-92zM87 280h266q-5 56-39.5 89t-88.5 33q-37 0-70.5-20t-51.5-53q-9-18-16-49z",
    glyphName: "e",
    horizAdvX: 426,
    unicode: "e"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M278 437v-44h-122v-393h-57v393h-94v44h94v72q0 98 48 147 47 48 126 53 25 1 51-4l-7-47q-21 3-44 2-57-3-87-36-30-34-30-116v-71h122z",
    glyphName: "f",
    horizAdvX: 283,
    unicode: "f"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M420 437v-41l-106 3q52-49 52-117 0-71-47.5-117t-121.5-46q-13 0-46 6-24-13-35-23t-12-23q-1-11 11.5-19t41.5-15l133-30q57-13 88-48t29-84q-3-68-62.5-112t-148.5-44q-86 0-141 42t-55 108q0 81 110 130-61 18-55 64 3 21 17 35t48 30q-94 48-94 153 0 66 47.5 113.5t114.5 47.5q38 0 77-13h155zM195 409q-48 0-80-32.5t-32-81.5q0-58 31.5-95.5t80.5-37.5q50 0 82.5 32t32.5 81q0 58-32.5 96t-82.5 38zM231-23l-85 18q-91-53-91-111 0-48 42.5-79.5t106.5-31.5q66 0 107 30t41 79q0 48-47 72-22 11-74 23z",
    glyphName: "g",
    horizAdvX: 419,
    unicode: "g"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 706h57v-330q70 73 141 73 74 0 116-42.5t42-116.5v-290h-57v262q0 75-27 105-31 33-84 33-68 0-131-72v-328h-57v706z",
    glyphName: "h",
    horizAdvX: 454,
    unicode: "h"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M108 437v-437h-57v437h57zM81 644q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "i",
    horizAdvX: 160,
    unicode: "i"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 437v-474q0-106-28-151-40-67-139-72-15-1-38 2l8 48q5 0 14-.5t10-.5q72 0 97 50 19 37 19 145v453h57zM79 644q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "j",
    horizAdvX: 160,
    unicode: "j"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 706h57v-480l225 216 56-12-184-177 209-253h-71l-180 220-55-54v-166h-57v706z",
    glyphName: "k",
    horizAdvX: 401,
    unicode: "k"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 706h57v-706h-57v706z",
    glyphName: "l",
    horizAdvX: 157,
    unicode: "l"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M679 0h-57v267q0 66-13 87-28 47-89 47-72 0-126-75 1-19 1-39v-287h-57v276q0 67-22 93-28 32-80 32-68 0-125-75v-326h-57v282q0 69-6 98t-25 46l47 23q30-26 37-78 54 78 142 78 98 0 131-81 28 33 49 48 48 33 97 33 92 0 131-61 22-35 22-100v-288z",
    glyphName: "m",
    horizAdvX: 727,
    unicode: "m"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M23 426l47 23q30-26 37-78 26 30 48 45 46 33 97 33 74 0 116-42t42-117v-290h-57v262q0 75-27 105-32 33-84 33-68 0-131-72v-328h-57v282q0 69-6 98t-25 46z",
    glyphName: "n",
    horizAdvX: 458,
    unicode: "n"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5z",
    glyphName: "o",
    horizAdvX: 488,
    unicode: "o"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M111 16v-285h-57v551q0 68-6 97t-25 47l47 23q25-22 32-50 57 44 131 49 90 6 150-59t60-169q0-99-61.5-163.5t-156.5-64.5q-58 0-114 24zM111 361v-292q60-34 114-31 71 3 114 52.5t43 127.5q0 82-43.5 132t-114.5 50q-55 0-113-39z",
    glyphName: "p",
    horizAdvX: 467,
    unicode: "p"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M414 410v-679h-57v309q-38-27-66.5-36.5t-70.5-9.5q-46 0-88 22t-68 59q-38 54-38 143 0 99 63.5 165t158.5 66q43 0 76-8t90-31zM357 85v290q-55 28-114 28-65 0-111-51.5t-46-124.5q0-82 39.5-131.5t107.5-53.5q64-3 124 43z",
    glyphName: "q",
    horizAdvX: 465,
    unicode: "q"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M299 431l-13-49q-33 15-64 15-48 0-112-95v-302h-57v282q0 69-6 98t-25 46l47 23q20-17 28-39t10-61q39 57 65 78.5t57 21.5q28 0 70-18z",
    glyphName: "r",
    horizAdvX: 301,
    unicode: "r"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M276 408l-21-45q-32 21-49.5 28t-38.5 9q-37 2-61.5-17t-24.5-49q0-33 27-51 21-15 76-38 61-26 84-54t23-77q0-29-17.5-58t-44.5-45q-36-21-87-21-84 0-140 60l29 40q48-54 116-54 41 0 65.5 20.5t24.5 55.5q0 38-33 58-16 11-31 17l-48 21q-50 22-71 44.5t-25 58.5q-6 56 32.5 96.5t96.5 40.5q65 0 118-40z",
    glyphName: "s",
    horizAdvX: 308,
    unicode: "s"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M274 437v-44h-123v-244q0-47 4-66t17-29q19-16 64-13 32 3 63 16l9-42q-51-23-111-23-32 0-57.5 15t-35.5 40q-10 26-10 95v251h-94v37l25 1q53 1 71 18 13 13 21 83l4 31h36l-6-126h123z",
    glyphName: "t",
    horizAdvX: 296,
    unicode: "t"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M397 437v-317q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-68 0-74 63-68-64-149-64-78 0-120 55-28 37-28 126v267h57v-266q0-80 31-108 30-25 78-25 35 0 62 12.5t64 45.5v341h57z",
    glyphName: "u",
    horizAdvX: 458,
    unicode: "u"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M197 76l3-8q14 40 16 45l21 54 110 279 50-15-173-431h-51l-171 431 55 15 107-279q18-47 24-66l7-17z",
    glyphName: "v",
    horizAdvX: 399,
    unicode: "v"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M300 446l107-280 12.5-33 12.5-33q10-32 11-37l16 46q1 3 20 57l109 280 49-15-171-431h-51l-98 255-94-255h-50l-171 431 54 15 112-286q23-61 37-103 17 54 37 106l53 143-49 125z",
    glyphName: "w",
    horizAdvX: 641,
    unicode: "w"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M199 266l132 180 51-16-154-204 166-217-56-16-142 193-142-195-52 16 165 218-157 205 56 16z",
    glyphName: "x",
    horizAdvX: 397,
    unicode: "x"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M57 446l105-279q14-37 35-99 14 40 16 45l21 54 108 279 51-15-211-524q-36-89-75.5-127t-97.5-38q-24 0-60 7l9 46q25-6 48-6 42 0 68.5 27.5t58.5 104.5l34 83-164 427z",
    glyphName: "y",
    horizAdvX: 394,
    unicode: "y"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M341 437l8-26-269-367h286l-10-44h-344l-8 27 269 366h-248v44h316z",
    glyphName: "z",
    horizAdvX: 372,
    unicode: "z"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM119 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM603 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "braceleft",
    horizAdvX: 711,
    unicode: "{"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM209 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM414 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "braceright",
    horizAdvX: 620,
    unicode: "}"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-12 0l228 558q-23 26-23 63t26 62.5 64 25.5 63-25 25-64q0-34-24-60l229-560h-66l-92 230h-277l-92-230h-61zM262 534l-102-256h238l-101 255q-7-1-16-1-11 0-19 2zM282 677q-24 0-39-16t-15-41q0-23 15.5-39.5t37.5-16.5q25 0 40 15.5t15 40.5q0 24-15.5 40.5t-38.5 16.5z",
    glyphName: "asciitilde",
    horizAdvX: 565,
    unicode: "~"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M113 0h-66l11 513h41zM78 662q17 0 28-12.5t11-31.5q0-18-11-30t-27-12q-18 0-29 12t-11 32q0 19 11 30.5t28 11.5z",
    glyphName: "exclamdown",
    horizAdvX: 182,
    unicode: "\xA1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M260 630v-83q67-4 120-43l-29-43q-57 37-110 37-68 0-112-49t-44-124q0-89 53-139 48-46 109-46 56 0 116 35l22-40q-56-41-125-46v-88h-44v88q-88 10-139.5 73.5t-51.5 162.5q0 85 54.5 148t136.5 73v84h44z",
    glyphName: "cent",
    horizAdvX: 388,
    unicode: "\xA2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M440 638l10-53q-32 7-59 4-80-9-115-74-19-34-43-136l-17-69h162v-45h-174l-22-96q-19-79-59-117h330l-10-52h-435v38q52 6 77 37t39 90l23 100h-117v45h129l24 97q18 73 35.5 111t46.5 68q54 55 139 55 15 0 36-3z",
    glyphName: "sterling",
    horizAdvX: 460,
    unicode: "\xA3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M41 148l58 57q9 9 21 17-37 49-37 107t37 107q-12 7-21 16l-58 58 34 34 58-58q6-5 17-21 49 37 106 37t107-37q11 16 17 21l57 58 35-34-58-58q-8-8-22-16 37-49 37-107 0-60-37-107 15-10 22-17l58-57-35-34-57 57q-8 8-17 22-49-37-107-37-57 0-106 37-9-14-17-22l-58-57zM256 457q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5q52 0 90 37.5t38 90.5-37.5 90.5-90.5 37.5z",
    glyphName: "currency",
    horizAdvX: 513,
    unicode: "\xA4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M346 685l-17-48q-49 23-90 23-43 0-71.5-29t-28.5-73q0-28 17-55.5t64-72.5q65-63 89-89.5t41-54.5q25-41 25-88 0-100-98-175 43-53 47-105 5-67-39-113.5t-116-51.5q-61-4-117 26l16 47q51-27 92-27 49 0 78.5 27t29.5 71q0 34-18 62.5t-76 84.5q-95 94-122 138t-27 102q0 74 52 129 18 20 46 39-39 52-39 103 0 62 44 105.5t111 47.5q52 3 107-23zM244 329l-97 96q-68-59-68-135 0-70 68-138l104-105q69 58 69 145 0 61-76 137z",
    glyphName: "section",
    horizAdvX: 399,
    unicode: "\xA7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-82 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM87 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "dieresis",
    unicode: "\xA8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183 416l19-40-126-151 126-149-19-47-163 194zM329 416l20-40-127-151 127-149-20-47-162 194z",
    glyphName: "guillemotleft",
    horizAdvX: 374,
    unicode: "\xAB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-119 630h236v-45h-236v45z",
    glyphName: "macron",
    unicode: "\xAF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M79 680l59-15-158-130-37 15z",
    glyphName: "acute",
    unicode: "\xB4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243-197v540q-79-1-123 22-37 21-58 56.5t-21 76.5q0 44 23.5 81.5t63.5 56.5q43 20 120 20h258v-24h-121v-829h-23v829h-96v-829h-23z",
    glyphName: "paragraph",
    horizAdvX: 524,
    unicode: "\xB6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M6-45l49-4q-16-39-54-97-26-38-49-67l-43 9q58 80 97 159z",
    glyphName: "cedilla",
    unicode: "\xB8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M191 29l-19 41 126 150-126 150 19 46 163-193zM45 29l-20 41 127 150-127 150 20 46 162-193z",
    glyphName: "guillemotright",
    horizAdvX: 374,
    unicode: "\xBB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M309 79l26-38q-64-47-138-47-72 0-122 46.5t-50 113.5q0 78 69 158l29 33.5 22 25.5t9 10q38 46 38 109 0 16-1 25h52q2-20 2-26 0-43-12-73.5t-46-72.5q-48-59-59-73.5t-20-32.5q-20-39-20-81 0-46 35.5-78.5t84.5-32.5q31 0 51.5 7t49.5 27zM217 582q-18 0-29 12t-11 31 11 30.5 28 11.5 28-12 11-31q0-18-11-30t-27-12z",
    glyphName: "questiondown",
    horizAdvX: 360,
    unicode: "\xBF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM205 826l136-130-37-15-158 129z",
    glyphName: "Agrave",
    horizAdvX: 565,
    unicode: "\xC0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM361 826l59-16-158-129-37 15z",
    glyphName: "Aacute",
    horizAdvX: 565,
    unicode: "\xC1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM192 679l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "Acircumflex",
    horizAdvX: 565,
    unicode: "\xC2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM402 800l31-6q-28-85-89-89-29-1-71 29-35 25-57 25-31 0-55-53l-29 7q17 47 37 66.5t51 21.5q31 1 70-28 37-27 57-27 33 0 55 54z",
    glyphName: "Atilde",
    horizAdvX: 565,
    unicode: "\xC3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM201 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM370 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Adieresis",
    horizAdvX: 565,
    unicode: "\xC4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-12 0l272 665q-67 18-67 87 0 37 26 62.5t64 25.5 63-25 25-64q0-32-18.5-55t-49.5-31l273-665h-66l-92 230h-277l-92-230h-61zM398 278l-89 223q-19 49-30 84-11-36-29-84l-90-223h238zM282 810q-25 0-40.5-16.5t-15.5-42.5q0-24 16-41t39-17q26 0 41.5 16t15.5 42q0 25-16.5 42t-39.5 17z",
    glyphName: "Aring",
    horizAdvX: 565,
    unicode: "\xC5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M455 243h-241l-160-243h-66l433 656h373v-52h-277v-232h249v-52h-249v-266h318l-9-54h-371v243zM455 294v318l-210-318h210z",
    glyphName: "AE",
    horizAdvX: 839,
    unicode: "\xC6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M554 617l-28-53q-90 49-175 49-115 0-187.5-78.5t-72.5-202.5q0-119 73-201 34-39 86.5-62.5t102.5-23.5q106 0 183 51l24-49q-87-61-210-61-65 0-128 26.5t-107 72.5q-90 93-90 249 0 68 27 134t73 110q94 92 232 92 106 0 197-53zM286-45l49-4q-18-44-54-97-26-38-49-67l-43 9q63 86 97 159z",
    glyphName: "Ccedilla",
    horizAdvX: 561,
    unicode: "\xC7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M391 656v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v656h339zM140 826l136-130-37-15-158 129z",
    glyphName: "Egrave",
    horizAdvX: 435,
    unicode: "\xC8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M391 656v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v656h339zM297 826l59-16-159-129-37 15z",
    glyphName: "Eacute",
    horizAdvX: 435,
    unicode: "\xC9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M391 656v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v656h339zM127 679l-42 11 111 137h45l111-137-48-11-87 111z",
    glyphName: "Ecircumflex",
    horizAdvX: 435,
    unicode: "\xCA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M391 656v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v656h339zM136 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM305 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Edieresis",
    horizAdvX: 435,
    unicode: "\xCB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 656v-656h-62v656h62zM5 826l136-130-37-15-158 129z",
    glyphName: "Igrave",
    horizAdvX: 166,
    unicode: "\xCC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 656v-656h-62v656h62zM162 826l59-16-158-129-37 15z",
    glyphName: "Iacute",
    horizAdvX: 166,
    unicode: "\xCD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 656v-656h-62v656h62zM-7 679l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "Icircumflex",
    horizAdvX: 166,
    unicode: "\xCE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M115 656v-656h-62v656h62zM2 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM171 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Idieresis",
    horizAdvX: 166,
    unicode: "\xCF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 654l34 11 345-414 117-145q0 18-.5 30.5t-.5 16v7 5 8.5q-1 34-1 76v407h55v-653l-30-11-348 417-47 57-71 88v-16q1-45 1-50 1-37 1-77v-411h-55v654zM447 800l30-6q-28-85-89-89-28-1-71 29-35 25-56 25-32 0-55-53l-30 7q18 47 37.5 67t50.5 21 71-28q36-27 57-27 32 0 55 54z",
    glyphName: "Ntilde",
    horizAdvX: 654,
    unicode: "\xD1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM278 826l136-130-36-15-159 129z",
    glyphName: "Ograve",
    horizAdvX: 711,
    unicode: "\xD2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM435 826l59-16-159-129-36 15z",
    glyphName: "Oacute",
    horizAdvX: 711,
    unicode: "\xD3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM266 679l-42 11 110 137h45l112-137-49-11-87 111z",
    glyphName: "Ocircumflex",
    horizAdvX: 711,
    unicode: "\xD4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM476 800l30-6q-28-85-88-89-29-1-71 29-35 25-57 25-32 0-55-53l-30 7q18 47 38 66.5t50 21.5q31 1 71-28 36-27 57-27 32 0 55 54z",
    glyphName: "Otilde",
    horizAdvX: 711,
    unicode: "\xD5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM274 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM444 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Odieresis",
    horizAdvX: 711,
    unicode: "\xD6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M101 508l156-156 156 156 34-34-156-156 156-156-34-34-156 156-156-156-34 34 156 156-156 156z",
    glyphName: "multiply",
    horizAdvX: 513,
    unicode: "\xD7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M546 614l48 64 41-7-59-79q111-100 111-265 0-152-92-246.5t-240-94.5q-105 0-188 57l-49-65-41 7 60 81q-112 100-112 268 0 141 94.5 238.5t230.5 97.5q115 0 196-56zM177 119l331 444q-74 52-160 52-114 0-185-78t-71-203q0-128 85-215zM536 539l-331-445q71-51 150-51 147 0 218 105 48 71 48 177 0 129-85 214z",
    glyphName: "Oslash",
    horizAdvX: 711,
    unicode: "\xD8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM232 826l136-130-36-15-159 129z",
    glyphName: "Ugrave",
    horizAdvX: 620,
    unicode: "\xD9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM389 826l59-16-159-129-36 15z",
    glyphName: "Uacute",
    horizAdvX: 620,
    unicode: "\xDA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM220 679l-42 11 110 137h45l112-137-49-11-87 111z",
    glyphName: "Ucircumflex",
    horizAdvX: 620,
    unicode: "\xDB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM228 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM398 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Udieresis",
    horizAdvX: 620,
    unicode: "\xDC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 355l206 312 55-18-233-349v-300h-62v300l-236 349 61 18zM347 826l59-16-159-129-36 15z",
    glyphName: "Yacute",
    horizAdvX: 536,
    unicode: "\xDD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 0v444q0 83 22 127 42 83 135 96 62 8 109-22.5t57-86.5q8-53-17-94-16-28-75-80-38-34-32-57 4-18 31-37l10-7 30-20 16-10q51-35 64-54 22-31 22-70 0-59-41.5-97t-106.5-38q-71 0-127 43l19 44q48-41 109-41 40 0 66 23t26 59q0 30-12.5 46.5t-58.5 46.5q-56 35-77 56-20 23-20 55 0 31 24 61 4 6 10 10l13 12 12 11 13 11q57 53 50 114-5 41-37.5 63t-75.5 15q-58-10-83-62-18-39-18-120v-441h-57z",
    glyphName: "germandbls",
    horizAdvX: 440,
    unicode: "\xDF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM112 680l136-130-37-15-158 130z",
    glyphName: "agrave",
    horizAdvX: 388,
    unicode: "\xE0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM269 680l59-15-158-130-37 15z",
    glyphName: "aacute",
    horizAdvX: 388,
    unicode: "\xE1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM100 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "acircumflex",
    horizAdvX: 388,
    unicode: "\xE2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM309 654l31-7q-28-84-89-88-29-1-71 29-35 25-56 25-32 0-56-54l-29 8q18 47 37.5 67t50.5 21 70-28q37-27 57-27 34 0 55 54z",
    glyphName: "atilde",
    horizAdvX: 388,
    unicode: "\xE3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM108 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM277 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "adieresis",
    horizAdvX: 388,
    unicode: "\xE4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M40 356v49q76 42 143 42 83 0 119-50 23-28 23-108v-169q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-7-40q-21-4-34-4-60 0-73 50-62-51-135-51-55 0-89.5 37t-31.5 92q6 107 146 139 30 6 104 14v23q1 58-23 81-26 26-74 23-65-4-131-42zM268 77v156q-105-13-147-38t-46-76q-2-37 21.5-60.5t62.5-23.5q52 0 109 42zM191 693q38 0 63-25t25-64q0-36-26.5-61.5t-63.5-25.5q-39 0-63.5 24.5t-24.5 63.5q0 37 26 62.5t64 25.5zM190 663q-25 0-40.5-16t-15.5-42q0-24 16-41t39-17q26 0 41.5 16t15.5 42q0 24-16.5 41t-39.5 17z",
    glyphName: "aring",
    horizAdvX: 388,
    unicode: "\xE5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M665 263l-22-28h-303q-1-57 17-99 20-44 59-70t85-26q81 0 135 54l29-33q-68-72-171-72-100 0-165 83-48-46-89-64.5t-93-18.5q-58 0-95 38t-34 94q3 58 42.5 91.5t123.5 49.5q28 6 105 14 2 33 1 45-3 42-31 63t-77 17q-68-4-133-45v50q69 38 145 43 53 3 89-19t48-65q61 84 154 84 54 0 96-24t64-67q19-39 20-95zM344 276h268q-5 59-40 92.5t-92 33.5q-52 0-89-34.5t-47-91.5zM286 237q-75-10-117-21-45-11-69.5-36t-24.5-59q0-39 24.5-62t65.5-23q58 0 109 40l35 29q-24 54-24 101 0 19 1 31z",
    glyphName: "ae",
    horizAdvX: 684,
    unicode: "\xE6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M380 404l-29-43q-57 38-110 38-68 0-112-48.5t-44-124.5q0-78 43-129.5t113-55.5q56-4 122 35l22-40q-63-47-144-47-97 0-156.5 64.5t-59.5 171.5q0 92 63 158t152 66q79 0 140-45zM200-45l49-4q-20-46-55-97-24-38-49-67l-42 9q58 80 97 159z",
    glyphName: "ccedilla",
    horizAdvX: 388,
    unicode: "\xE7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 239h-300v-19q0-77 45.5-128.5t114.5-51.5q78 0 133 52l30-33q-69-70-172-70-50 0-95 23t-74 64q-41 58-41 152 0 90 60 155.5t142 65.5q111 0 158-90 21-37 22-92zM87 280h266q-5 56-39.5 89t-88.5 33q-37 0-70.5-20t-51.5-53q-9-18-16-49zM135 680l136-130-37-15-158 130z",
    glyphName: "egrave",
    horizAdvX: 426,
    unicode: "\xE8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 239h-300v-19q0-77 45.5-128.5t114.5-51.5q78 0 133 52l30-33q-69-70-172-70-50 0-95 23t-74 64q-41 58-41 152 0 90 60 155.5t142 65.5q111 0 158-90 21-37 22-92zM87 280h266q-5 56-39.5 89t-88.5 33q-37 0-70.5-20t-51.5-53q-9-18-16-49zM292 680l59-15-158-130-37 15z",
    glyphName: "eacute",
    horizAdvX: 426,
    unicode: "\xE9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 239h-300v-19q0-77 45.5-128.5t114.5-51.5q78 0 133 52l30-33q-69-70-172-70-50 0-95 23t-74 64q-41 58-41 152 0 90 60 155.5t142 65.5q111 0 158-90 21-37 22-92zM87 280h266q-5 56-39.5 89t-88.5 33q-37 0-70.5-20t-51.5-53q-9-18-16-49zM123 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "ecircumflex",
    horizAdvX: 426,
    unicode: "\xEA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M384 239h-300v-19q0-77 45.5-128.5t114.5-51.5q78 0 133 52l30-33q-69-70-172-70-50 0-95 23t-74 64q-41 58-41 152 0 90 60 155.5t142 65.5q111 0 158-90 21-37 22-92zM87 280h266q-5 56-39.5 89t-88.5 33q-37 0-70.5-20t-51.5-53q-9-18-16-49zM132 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM301 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "edieresis",
    horizAdvX: 426,
    unicode: "\xEB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M107 437v-437h-57v437h57zM1 680l136-130-37-15-158 130z",
    glyphName: "igrave",
    horizAdvX: 157,
    unicode: "\xEC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M108 437v-437h-57v437h57zM158 680l59-15-158-130-37 15z",
    glyphName: "iacute",
    horizAdvX: 157,
    unicode: "\xED"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M107 437v-437h-57v437h57zM-12 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "icircumflex",
    horizAdvX: 157,
    unicode: "\xEE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M107 437v-437h-57v437h57zM-3 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM166 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "idieresis",
    horizAdvX: 157,
    unicode: "\xEF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M23 426l47 23q30-26 37-78 26 30 48 45 46 33 97 33 74 0 116-42t42-117v-290h-57v262q0 75-27 105-32 33-84 33-68 0-131-72v-328h-57v282q0 69-6 98t-25 46zM349 654l31-7q-28-84-89-88-29-1-71 29-35 25-56 25-32 0-56-54l-29 8q18 47 37.5 67t50.5 21 70-28q37-27 57-27 34 0 55 54z",
    glyphName: "ntilde",
    horizAdvX: 458,
    unicode: "\xF1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5zM166 680l136-130-37-15-158 130z",
    glyphName: "ograve",
    horizAdvX: 488,
    unicode: "\xF2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5zM323 680l59-15-158-130-37 15z",
    glyphName: "oacute",
    horizAdvX: 488,
    unicode: "\xF3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5zM154 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "ocircumflex",
    horizAdvX: 488,
    unicode: "\xF4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5zM363 654l31-7q-28-84-89-88-29-1-71 29-35 25-56 25-32 0-56-54l-29 8q18 47 37.5 67t50.5 21 70-28q37-27 57-27 34 0 55 54z",
    glyphName: "otilde",
    horizAdvX: 488,
    unicode: "\xF5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M243 448q94 0 156.5-63.5t62.5-159.5q0-104-59-170t-153-66q-119 0-178 81-47 61-47 148 0 98 62.5 164t155.5 66zM236 399q-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q70 0 113 48t43 127q0 83-46.5 135.5t-120.5 52.5zM162 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM331 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "odieresis",
    horizAdvX: 488,
    unicode: "\xF6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M256 503q14 0 24.5-10.5t10.5-24.5-10.5-24.5-24.5-10.5-24.5 10.5-10.5 24.5 10.5 24.5 24.5 10.5zM256 202q14 0 24.5-10.5t10.5-24.5-10.5-24.5-24.5-10.5-24.5 10.5-10.5 24.5 10.5 24.5 24.5 10.5zM47 341h418v-47h-418v47z",
    glyphName: "divide",
    horizAdvX: 513,
    unicode: "\xF7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M367 412l36 48 35-7-45-61q69-66 69-167 0-104-59-170t-153-66q-76 0-130 35l-35-47-36 7 45 61q-69 67-69 172 0 99 62.5 165t155.5 66q70 0 124-36zM129 92l205 276q-43 31-98 31-67 0-109.5-48.5t-42.5-125.5q0-76 45-133zM359 345l-206-276q42-33 94-33 71 0 113.5 48t42.5 127q0 82-44 134z",
    glyphName: "oslash",
    horizAdvX: 488,
    unicode: "\xF8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M397 437v-317q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-68 0-74 63-68-64-149-64-78 0-120 55-28 37-28 126v267h57v-266q0-80 31-108 30-25 78-25 35 0 62 12.5t64 45.5v341h57zM152 680l136-130-37-15-158 130z",
    glyphName: "ugrave",
    horizAdvX: 458,
    unicode: "\xF9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M397 437v-317q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-68 0-74 63-68-64-149-64-78 0-120 55-28 37-28 126v267h57v-266q0-80 31-108 30-25 78-25 35 0 62 12.5t64 45.5v341h57zM309 680l59-15-158-130-37 15z",
    glyphName: "uacute",
    horizAdvX: 458,
    unicode: "\xFA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M397 437v-317q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-68 0-74 63-68-64-149-64-78 0-120 55-28 37-28 126v267h57v-266q0-80 31-108 30-25 78-25 35 0 62 12.5t64 45.5v341h57zM139 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "ucircumflex",
    horizAdvX: 458,
    unicode: "\xFB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M397 437v-317q0-54 6-67 7-20 37-20 1 0 8.5.5t11.5.5l-8-40q-19-4-33-4-68 0-74 63-68-64-149-64-78 0-120 55-28 37-28 126v267h57v-266q0-80 31-108 30-25 78-25 35 0 62 12.5t64 45.5v341h57zM148 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM317 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "udieresis",
    horizAdvX: 458,
    unicode: "\xFC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M57 446l105-279q14-37 35-99 14 40 16 45l21 54 108 279 51-15-211-524q-36-89-75.5-127t-97.5-38q-24 0-60 7l9 46q25-6 48-6 42 0 68.5 27.5t58.5 104.5l34 83-164 427zM276 680l59-15-159-130-36 15z",
    glyphName: "yacute",
    horizAdvX: 394,
    unicode: "\xFD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M57 446l105-279q14-37 35-99 14 40 16 45l21 54 108 279 51-15-211-524q-36-89-75.5-127t-97.5-38q-24 0-60 7l9 46q25-6 48-6 42 0 68.5 27.5t58.5 104.5l34 83-164 427zM115 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM284 641q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "ydieresis",
    horizAdvX: 394,
    unicode: "\xFF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M107 437v-437h-57v437h57z",
    glyphName: "dotlessi",
    horizAdvX: 157,
    unicode: "\u0131"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M524 628v28h339v-52h-277v-232h249v-52h-249v-266h319l-10-54h-371v27q-78-41-170-41-144 0-237 98t-93 250q0 141 94.5 238.5t230.5 97.5q99 0 175-42zM524 89v471q-92 55-176 55-115 0-186-77.5t-71-202.5q0-62 23-119.5t63-97.5q34-34 82-54.5t95-20.5q52 0 88 10t82 36z",
    glyphName: "OE",
    horizAdvX: 907,
    unicode: "\u0152"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M697 92l30-33q-69-70-172-70-89 0-152 66-61-66-153-66-118 0-178 81-47 63-47 148 0 98 62.5 164t155.5 66q100 0 160-66 62 67 144 67 110 0 159-90 21-41 21-92l-23-28h-299q-1-8-1-19 0-77 45.5-128.5t114.5-51.5q80 0 133 52zM373 337q-44 62-137 62-67 0-109.5-48.5t-42.5-125.5q0-80 47-134.5t116-54.5q43 0 69.5 11.5t59.5 45.5q-19 37-25 64t-6 71q0 55 28 109zM407 280h267q-5 56-40 89t-89 33q-37 0-70.5-20t-51.5-53q-9-18-16-49z",
    glyphName: "oe",
    horizAdvX: 745,
    unicode: "\u0153"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M373 612l-27-54q-68 57-133 57-51 0-84-29.5t-35-78.5q-3-62 49-95 23-15 53-29l20-10 21-9 20-10q86-40 112-85 24-41 24-97 0-81-57.5-133.5t-146.5-52.5q-100 0-187 69l16 64q85-79 170-79 66 0 104 34t38 93q0 62-45 96-20 16-59 35l-60 27q-73 34-102.5 72.5t-29.5 99.5q0 73 52.5 123t128.5 50q91 0 158-58zM300 827l42-11-111-137h-45l-111 137 48 11 88-111z",
    glyphName: "Scaron",
    horizAdvX: 415,
    unicode: "\u0160"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M276 408l-21-45q-32 21-49.5 28t-38.5 9q-37 2-61.5-17t-24.5-49q0-33 27-51 21-15 76-38 61-26 84-54t23-77q0-29-17.5-58t-44.5-45q-36-21-87-21-84 0-140 60l29 40q48-54 116-54 41 0 65.5 20.5t24.5 55.5q0 38-33 58-16 11-31 17l-48 21q-50 22-71 44.5t-25 58.5q-6 56 32.5 96.5t96.5 40.5q65 0 118-40zM246 681l42-11-111-137h-45l-111 137 48 11 88-111z",
    glyphName: "scaron",
    horizAdvX: 308,
    unicode: "\u0161"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 355l206 312 55-18-233-349v-300h-62v300l-236 349 61 18zM186 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5zM356 787q16 0 26.5-10.5t10.5-26.5-10.5-26.5-26.5-10.5-26.5 10.5-10.5 26.5 10.5 26.5 26.5 10.5z",
    glyphName: "Ydieresis",
    horizAdvX: 536,
    unicode: "\u0178"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M41 656h460l11-24-415-578h436l-10-54h-508l-11 24 417 580h-380v52zM361 827l43-11-111-137h-45l-112 137 49 11 87-111z",
    glyphName: "Zcaron",
    horizAdvX: 538,
    unicode: "\u017D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M341 437l8-26-269-367h286l-10-44h-344l-8 27 269 366h-248v44h316zM278 681l42-11-111-137h-45l-111 137 48 11 88-111z",
    glyphName: "zcaron",
    horizAdvX: 372,
    unicode: "\u017E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-90 534l-42 11 111 137h45l111-137-48-11-88 111z",
    glyphName: "circumflex",
    unicode: "\u02C6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M93 681l42-11-111-137h-45l-111 137 48 11 88-111z",
    glyphName: "caron",
    unicode: "\u02C7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M90 669l34-4q-17-119-125-119-107 0-124 119l37 4q18-80 88-80 38 0 59 18.5t31 61.5z",
    glyphName: "breve",
    unicode: "\u02D8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M1 693q38 0 63-25t25-64q0-36-26.5-61.5t-63.5-25.5q-39 0-63.5 24.5t-24.5 63.5q0 37 26 62.5t64 25.5zM0 663q-25 0-40.5-16t-15.5-42q0-24 16-41t39-17q26 0 41.5 16t15.5 42q0 24-16.5 41t-39.5 17z",
    glyphName: "ring",
    unicode: "\u02DA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M120 654l31-7q-28-84-89-88-29-1-71 29-35 25-56 25-32 0-56-54l-29 8q18 47 37.5 67t50.5 21 70-28q37-27 57-27 34 0 55 54z",
    glyphName: "tilde",
    unicode: "\u02DC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M33 262h440l-8-47h-440z",
    glyphName: "endash",
    horizAdvX: 499,
    unicode: "\u2013"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M33 262h440l-8-47h-440z",
    glyphName: "emdash",
    horizAdvX: 499,
    unicode: "\u2014"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M78 420l-53 6q14 120 99 249l46-10q-80-138-92-245z",
    glyphName: "quoteleft",
    horizAdvX: 191,
    unicode: "\u2018"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M112 675l53-6q-14-122-99-248l-46 10q80 137 92 244z",
    glyphName: "quoteright",
    horizAdvX: 191,
    unicode: "\u2019"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M212 421l-53 6q14 119 99 248l46-10q-78-137-92-244zM78 421l-53 6q14 121 99 248l46-10q-80-139-92-244z",
    glyphName: "quotedblleft",
    horizAdvX: 324,
    unicode: "\u201C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M112 675l53-6q-14-122-99-248l-46 10q80 137 92 244zM247 675l52-6q-14-121-99-248l-46 10q79 136 93 244z",
    glyphName: "quotedblright",
    horizAdvX: 324,
    unicode: "\u201D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M52 107l53-6q-14-121-99-250l-46 11q80 138 92 245zM187 107l52-6q-14-117-98-250l-47 11q79 137 93 245z",
    glyphName: "quotedblbase",
    horizAdvX: 264,
    unicode: "\u201E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M257 656v-191h178v-51h-178v-463h-55v463h-177v51h177v191h55z",
    glyphName: "dagger",
    horizAdvX: 460,
    unicode: "\u2020"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M174 646q69 4 114.5-47.5t45.5-133.5q0-87-44.5-139.5t-118.5-52.5q-68 0-110.5 52.5t-42.5 136.5q0 78 43 129t113 55zM172 602q-48 0-74.5-36.5t-26.5-102.5q0-64 29.5-104.5t75.5-40.5q103 0 103 143 0 60-30 102-28 39-77 39zM477 645h46l-264-645h-46zM557 372q69 4 114.5-48t45.5-133q0-87-44.5-139.5t-118.5-52.5q-68 0-110.5 52.5t-42.5 136.5q0 79 43 129.5t113 54.5zM555 328q-48 0-74.5-36.5t-26.5-102.5q0-64 29.5-104.5t75.5-40.5q103 0 103 143 0 60-30 102-28 39-77 39zM910 372q69 4 114.5-48t45.5-133q0-87-44.5-139.5t-118.5-52.5q-68 0-110.5 52.5t-42.5 136.5q0 79 43 129.5t113 54.5zM908 328q-48 0-74.5-36.5t-26.5-102.5q0-64 29.5-104.5t75.5-40.5q103 0 103 143 0 60-30 102-28 39-77 39z",
    glyphName: "perthousand",
    horizAdvX: 1090,
    unicode: "\u2030"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183 416l19-40-126-151 126-149-19-47-163 194z",
    glyphName: "guilsinglleft",
    horizAdvX: 228,
    unicode: "\u2039"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M45 29l-20 41 127 150-127 150 20 46 162-193z",
    glyphName: "guilsinglright",
    horizAdvX: 228,
    unicode: "\u203A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M343-11q-103 0-177.5 72t-93.5 188h-65l20 48h40v19q0 21 1 33h-61l21 48h47q22 112 95.5 182t172.5 70q83 0 157-50l-26-48q-72 46-136 46-80 0-132.5-55t-69.5-145h276l-20-48h-261q-1-10-1-26t1-26h239l-21-48h-212q19-93 77.5-150t140.5-57q34 0 57.5 9.5t64.5 34.5l28-46q-63-51-162-51z",
    glyphName: "Euro",
    horizAdvX: 513,
    unicode: "\u20AC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M49 341h418v-47h-418v47z",
    glyphName: "minus",
    horizAdvX: 513,
    unicode: "\u2212"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M510 0l-92 230h-277l-92-230h-61l275 673h37l276-673h-66zM398 278l-89 223q-21 55-30 84-11-36-29-84l-90-223h238zM153 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM414 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "Adieresis.alt",
    horizAdvX: 565,
    unicode: "\uE000"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-12 0l228 558q-23 26-23 63t26 62.5 64 25.5 63-25 25-64q0-34-24-60l229-560h-66l-92 230h-277l-92-230h-61zM262 534l-102-256h238l-101 255q-7-1-16-1-11 0-19 2zM282 677q-24 0-39-16t-15-41q0-23 15.5-39.5t37.5-16.5q25 0 40 15.5t15 40.5q0 24-15.5 40.5t-38.5 16.5z",
    glyphName: "Aring.alt",
    horizAdvX: 565,
    unicode: "\uE001"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M350 670q104 0 176-42 77-44 119-122.5t42-178.5q0-152-92-246.5t-240-94.5q-144 0-237 98t-93 250q0 80 33 150t92 117q41 32 95 50.5t105 18.5zM349 615q-115 0-186-78t-71-203q0-62 23-119t63-97q34-34 82-54.5t95-20.5q147 0 218 105 48 71 48 177 0 124-78 207t-194 83zM119 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM603 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "Odieresis.alt",
    horizAdvX: 711,
    unicode: "\uE002"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M50 656h62v-382q0-87 12-123 18-52 68-81t120-29q115 0 166 72 30 44 30 148v395h62v-393q0-88-18.5-138t-62.5-85q-71-54-184-54-91 0-154.5 37.5t-86.5 104.5q-14 45-14 136v392zM209 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5zM414 680q17 0 28.5-11.5t11.5-28.5-11.5-28.5-28.5-11.5-28.5 11.5-11.5 28.5 11.5 28.5 28.5 11.5z",
    glyphName: "Udieresis.alt",
    horizAdvX: 620,
    unicode: "\uE003"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: ",",
    u2: "1"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "-",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "-",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "-",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "-",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "-",
    u2: "J"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "-",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: ".",
    u2: "1"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "2",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "3",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "4",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "4",
    u2: "1"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "5",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "6",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "7",
    u2: ":"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "7",
    u2: "9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "7",
    u2: "8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "7",
    u2: "6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "7",
    u2: "4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "7",
    u2: "3"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "7",
    u2: "2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "7",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "7",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "8",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "9",
    u2: "7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "A",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "A",
    u2: "\u2019"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "A",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "A",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "A",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "A",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "A",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "q"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "A",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "A",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: -10,
    u1: "A",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "A",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "A",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "A",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "A",
    u2: "U"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "A",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "A",
    u2: "Q"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "A",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "A",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "A",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "A",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "B",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "B",
    u2: "X"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "B",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "B",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "B",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "C",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "C",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "C",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "C",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: -10,
    u1: "C",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "D",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "D",
    u2: "X"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "D",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "D",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "D",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "D",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "E",
    u2: "q"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "E",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "E",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "E",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "E",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "E",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "Q"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "E",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "F",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "F",
    u2: "r"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "F",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "F",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "F",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "F",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "F",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "F",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "G",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "G",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "G",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "K",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "K",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "K",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "K",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "L",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "L",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "L",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "L",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "L",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "L",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "L",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "L",
    u2: "U"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "L",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "L",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "L",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "L",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "L",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "M",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "M",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "O",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "O",
    u2: "X"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "O",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "O",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "O",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "O",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "P",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "P",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "P",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "P",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "P",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "P",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "P",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "R",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "R",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "R",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "R",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "R",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "R",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "R",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "R",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "R",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "R",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "R",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "R",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "R",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "S",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "S",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "S",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "S",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "T",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "T",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "s"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "r"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 155,
    u1: "T",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "T",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "T",
    u2: "S"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "T",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "T",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "T",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "T",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "T",
    u2: ";"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "T",
    u2: ":"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "T",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "T",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "T",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "U",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "U",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "U",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "V",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "V",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "V",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "V",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "V",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "V",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "V",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "V",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "V",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "V",
    u2: "M"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "V",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "V",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "V",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "V",
    u2: ";"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "V",
    u2: ":"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "V",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "V",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "V",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "W",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "W",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "W",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "W",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "W",
    u2: "r"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "W",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "W",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "W",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "W",
    u2: "S"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "W",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "W",
    u2: "M"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "W",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "W",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "W",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "W",
    u2: ";"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "W",
    u2: ":"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "W",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "W",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "W",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "X",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "X",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "X",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "X",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "X",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "X",
    u2: "Q"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "X",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "X",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 68,
    u1: "X",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "X",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "Y",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "Y",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 87,
    u1: "Y",
    u2: "u"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "Y",
    u2: "p"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "Y",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "Y",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "Y",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "Y",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "Y",
    u2: "S"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "Y",
    u2: "O"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "Y",
    u2: "G"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "Y",
    u2: "C"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 126,
    u1: "Y",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "Y",
    u2: ";"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 58,
    u1: "Y",
    u2: ":"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "Y",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "Y",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "Y",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "Z",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "a",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "a",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "a",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "a",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "a",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "a",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "b",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "b",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "b",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "b",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "b",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "c",
    u2: "\u2039"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "c",
    u2: "\xAB"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "k"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "h"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "c",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "d",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "e",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "e",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "e",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "e",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "e",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "e",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "f",
    u2: "\xE4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "f",
    u2: "\xE2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "f",
    u2: "s"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "f",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "f",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "f",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "\xE4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "\xE2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "g",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: -58,
    u1: "g",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "h",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "h",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "h",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "h",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "k",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "k",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "k",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "k",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "m",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "m",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "m",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "m",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "m",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "n",
    u2: "z"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "n",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "n",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "n",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "n",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "n",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "o",
    u2: "z"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "o",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "o",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "o",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "o",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "o",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "o",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "p",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "p",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "p",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "p",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "p",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "r",
    u2: "\xE4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "r",
    u2: "\xE2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "r",
    u2: "s"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "r",
    u2: "l"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "r",
    u2: "k"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "r",
    u2: "h"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "r",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "r",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "r",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "r",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "r",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "r",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "s",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "s",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "s",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "s",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "t",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "t",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "t",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 49,
    u1: "t",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "t",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "v",
    u2: "\xE4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "v",
    u2: "\xE2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "v",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "v",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "v",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "v",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "v",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "v",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "w",
    u2: "\xE4"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "w",
    u2: "\xE2"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "w",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "w",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "w",
    u2: "a"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "w",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "w",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "w",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "x",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "y",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "y",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "y",
    u2: "."
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "y",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 78,
    u1: "y",
    u2: ","
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "\xF6"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "\xEA"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "\xE9"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "\xE8"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "\xE7"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "z",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 39,
    u1: "z",
    u2: "-"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "\xBB",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\xBB",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\xBB",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "\xBB",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xBB",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE2",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE2",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE2",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE2",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE2",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE2",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE2",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE2",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE2",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE2",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE4",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE4",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE4",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE4",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE4",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE4",
    u2: "g"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xE4",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE4",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE4",
    u2: "d"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE4",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xE7",
    u2: "o"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xE7",
    u2: "k"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xE7",
    u2: "h"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xE7",
    u2: "e"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xE7",
    u2: "c"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE8",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE8",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE8",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE8",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE8",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE8",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE9",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE9",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE9",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xE9",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE9",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xE9",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xEA",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xEA",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xEA",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 6,
    u1: "\xEA",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xEA",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 10,
    u1: "\xEA",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xF6",
    u2: "z"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xF6",
    u2: "y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xF6",
    u2: "x"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xF6",
    u2: "w"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\xF6",
    u2: "v"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xF6",
    u2: "t"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 29,
    u1: "\xF6",
    u2: "f"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 146,
    u1: "\u2019",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "\u201C",
    u2: "A"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "\u201E",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\u201E",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\u201E",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "\u201E",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 136,
    u1: "\u203A",
    u2: "Y"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\u203A",
    u2: "W"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 97,
    u1: "\u203A",
    u2: "V"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 116,
    u1: "\u203A",
    u2: "T"
  }), /*#__PURE__*/React.createElement("hkern", {
    k: 19,
    u1: "\u203A",
    u2: "A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayShopLight);
export default __webpack_public_path__ + "static/media/TodaySHOP-Light.251cff2fcc5cb4c49b3d04f30989290a.svg";
export { ForwardRef as ReactComponent };